export default __webpack_public_path__ + "static/media/portfolio-twitter.ea6ee18a.svg";